export default {
  sm: `
  For<br>
  tomorrow,<br>
  technology<br> 
  that<br> 
  protects today
  `,
  md: `
  For tomorrow,<br>
  technology that<br> 
  protects today
  `,
  lg: `
  For tomorrow,<br>
  technology that<br> 
  protects today
  `,
  xxl: `
  For tomorrow,<br>
  technology that<br> 
  protects today
  `,
};
